export const iconFontAwesomeConstructionBucket = (
	<i className="fa-solid fa-bucket"></i>
);
